import React from "react"
import PropTypes from "prop-types"
import Component from "./Component";

class Select extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emptyOption: this.props.emptyOption,
      options: [...this.props.options],
      optionsValue: this.props.optionsValue ? this.props.optionsValue : "id",
      optionsLabel: this._getLabelFunction(),
      multiselectValues: [],
      multiselectCodes: [],
      multiselectItems: [],
      filter: "",
      lastValue: "",
      searchText: ""
    };
    this.input = React.createRef();
    this.dropdown = React.createRef();

    this._onInputKeyDown = this._onInputKeyDown.bind(this); //we bound keydown method, since we need the same method to remove event
  }

  componentDidMount() {
    this.setState({
      ...this.state,
      filter: this.getValue(),
      lastValue: this.getValue(),
    })
    //we use plain events for keydown since we want to cancel them, which is not possible with react synthetic events
    this.input.current.addEventListener("keydown", this._onInputKeyDown, false);
  }

  componentWillUnmount() {
    this.input.current.removeEventListener("keydown", this._onInputKeyDown, false);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(!this.props.isMultiSelect && (prevProps.options !== this.props.options || this.valueDidUpdate(prevProps))) {
      const value = this.getValue();
      this.setState({
        ...this.state,
        options: [...this.props.options],
        filter: value,
        lastValue: value,
      }, () => this._onInputFocus(false));
      return;
    }
    let multiSelectOptions = {}
    if(this.props.isMultiSelect &&
      this.state.multiSelectOptions !== this.props.multiSelectValues &&
      this.state.multiselectValues.length === 0) {
      multiSelectOptions = {
        multiselectValues: this.props.multiSelectValues ? this.props.multiSelectValues.multiselectValues : [],
        multiselectCodes: this.props.multiSelectValues ? this.props.multiSelectValues.multiselectCodes : [],
        multiselectItems: this.props.multiSelectValues ? this.props.multiSelectValues.multiselectItems : [],
        multiSelectOptions: this.props.multiSelectValues,
      }
    }
    if (prevProps.options !== this.props.options || this.valueDidUpdate(prevProps)) {
      const value = this.getValue();
      this.setState({
        emptyOption: this.props.emptyOption,
        options: [...this.props.options],
        optionsValue: this.props.optionsValue ? this.props.optionsValue : "id",
        optionsCode: this.props.optionsCode ? this.props.optionsCode :"code",
        optionsLabel: this._getLabelFunction(),
        filter: value,
        lastValue: value,
        ...multiSelectOptions
      }, () => this._onInputFocus(false))
    }
  }

  render() {
    return (
      <label className={"field has-float-label dropdown select loadable " + (this.props.className ? this.props.className : "")}>
        <input ref={this.input}
               id={this.props.code}
               name={this.props.name}
               value={this.props.isMultiSelect ? this.getMultiSelectText() : this.state.filter}
               disabled={this.props.disabled}
               type="text"
               placeholder=" "
               autoComplete="off"
               spellCheck="false"
               className={!this.props.skipValidation && this.isInvalid() ? "is-invalid input" : "input"}
               onFocus={this._onInputFocus.bind(this)}
               onBlur={this._onInputBlur.bind(this)}
               onChange={this._onInputChange.bind(this)}
               onKeyDown={this.props.isMultiSelect ? this._onInputChange.bind(this) : null}/>
        <span>{this.props.label}</span>
        <div className="error-icon fz fz-exclamation-triangle solid">
          <div className="has-tooltip danger" data-tooltip={this.errorMessage()}/>
        </div>
        <div className="dropdown-indicator right-decoration fz fz-chevron-down"/>
        {this.props.isMultiSelect ?
          <div
            className="dropdown-container"
            ref={this.dropdown}
            onMouseDownCapture={(e) => this.props.isMultiSelect && e.preventDefault()}>
            <label>
              <input
                ref={this.input}
                value={this.state.searchText}
                className="input"
                type="text"
                placeholder={this.props.searchLabel}
                onChange={this._onInputChange.bind(this)}/>
            </label>
              <ul className="scrollbar"
              //we use mouse down since we need event which comes before blur (otherwise the dropdown is already closed
                onMouseDown={this._onDropdownClick.bind(this)}
                onMouseMove={this._onDropdownMouseMove.bind(this)}>
              {
                this.state.multiselectItems.map((option, index) =>
                this.getOptionVisible(option) &&
                <li
                  className={(this.props.isMultiSelect && this.state.multiselectValues.includes(this.getOptionValue(option)))? "selected" : ""}
                  key={index}
                  data-index={index}
                  data-id={this.getOptionValue(option)}>
                    <input
                      type="checkbox"
                      id={index}
                      data-index={index}
                      data-id={this.getOptionValue(option)}
                      checked={(this.props.isMultiSelect && this.state.multiselectValues.includes(this.getOptionValue(option)))}
                      onChange={this._onInputChange.bind(this)}/>
                    {this.getOptionLabel(option)}
                </li>
                )
              }
            </ul>
            <div className={"line " + ((this.props.isMultiSelect && this.state.multiselectItems.length > 0 && this.state.options.length > 0)? "show" : "")}/>
            <ul className="scrollbar"
              //we use mouse down since we need event which comes before blur (otherwise the dropdown is already closed
                onMouseDown={this._onDropdownClick.bind(this)}
                onMouseMove={this._onDropdownMouseMove.bind(this)}>
              {
                this.state.options.map((option, index) => {
                  if (this.state.multiselectValues.includes(option.id)) {
                    return null;
                  }
                  return this.getOptionVisible(option) && (
                    <li
                      className={(this.props.isMultiSelect && this.state.multiselectValues.includes(this.getOptionValue(option))) ? "selected" : ""}
                      key={index}
                      data-index={index}
                      data-id={this.getOptionValue(option)}
                    >
                      <input
                        type="checkbox"
                        id={index}
                        data-index={index}
                        data-id={this.getOptionValue(option)}
                        checked={this.props.isMultiSelect &&
                          this.state.multiselectValues.includes(this.getOptionValue(option)) &&
                          this.state.multiselectItems.includes(option)}
                        onChange={this._onInputChange.bind(this)}
                      />
                      {this.getOptionLabel(option)}
                    </li>
                  );
                })
              }
          </ul>
          </div>
        :
          <ul ref={this.dropdown}
              className="dropdown-container scrollbar"
            //we use mouse down since we need event which comes before blur (otherwise the dropdown is already closed
              onMouseDown={this._onDropdownClick.bind(this)}
              onMouseMove={this._onDropdownMouseMove.bind(this)}>
            {
              this.state.emptyOption &&
              <li data-index={-1} className="empty"
                  data-id={null}>{this.props.emptyLabel || "\u00A0"}</li>
            }
            {
              this.state.options.map((option, index) =>
                this.getOptionVisible(option) &&
                <li key={index}
                    data-index={index}
                    data-id={this.getOptionValue(option)}>{this.getOptionLabel(option)}</li>
              )
            }
          </ul>
        }

      </label>
    )
  }

  getValue() {
    const val = super.getValue() ? super.getValue() : this.props.selectedItem;
    const item = this.props.options.find(function (item) {
      return item === val || String(this.getOptionValue(item)) === String(val) || this.getOptionValue(item) === this.getOptionValue(val);
    }.bind(this));

    if (this.props.isMultiSelect && val) {
      val.map((stage) => {
        if (!this.state.multiselectItems.includes(stage) &&
        typeof stage === "object" &&
        stage !== null &&
        stage !== undefined) {
          this.state.multiselectItems.push(stage);
          this.state.multiselectValues.push(stage.id);
          this.state.multiselectCodes.push(stage.code);
        }
      });
    }
    return item ? this.getOptionLabel(item) : "";
  }

  getValueProps() {
    return "selectedItem";
  }

  getEventValue(item) {
    return item;
  }

  getMultiSelectText() {
    if(this.state.multiselectCodes.length === 0) {
      return "";
    }
    return this.state.multiselectCodes.join(", ")
  }

  isInvalid() {
    return this.props.isInvalid || super.isInvalid();
  }

  getOptionVisible(option) {
    return option && this.props.optionsVisible ? this.props.optionsVisible(option) : true;
  }

  getOptionValue(option) {
    return option && option[this.state.optionsValue];
  }

  getOptionCode(option) {
    return option && option[this.state.optionsCode];
  }

  getOptionLabel(option) {
    if (option === null) {
      return "";
    }
    return this.state.optionsLabel(option);
  }

  _getLabelFunction() {
    switch (typeof this.props.optionsLabel) {
      case "function":
        return this.props.optionsLabel;
      case "string":
        return item => item[this.props.optionsLabel];
      default:
        return item => item["name"];
    }
  }

  _onInputChange(event) {
    if(!this.props.isMultiSelect) {
      const filter = event.currentTarget.value.toLowerCase();
      const options = this.props.options.filter(function (option) {
        return this.getOptionLabel(option).toLowerCase().indexOf(filter) > -1;
      }.bind(this));

      if (this.currentHover) {
        //hover item which will be visible after filtering
        let item = this.currentHover;
        if (this.currentHover.classList.contains("empty")) {
          item = this.currentHover.nextElementSibling;
        } else {
          let index = parseInt(this.currentHover.getAttribute("data-index"));
          while (options.length <= index && item) {
            item = item.previousElementSibling;
            index--;
          }
        }
        item && this._hoverItem(item);
      }

      this.setState({
        ...this.state,
        emptyOption: filter.length > 0 ? false : this.props.emptyOption,
        options: options,
        filter: filter
      });
      return
    }

    if (event.key ==="Backspace") {
      this.state.searchText = this.state.searchText.slice(0, -1);
    }else if (
      (event.keyCode >= 48 && event.keyCode <= 57) || // numbers
      (event.keyCode >= 65 && event.keyCode <= 90) || // uppercase letters
      (event.keyCode >= 97 && event.keyCode <= 122) || // lowercase letters
      (event.keyCode >= 219 && event.keyCode <= 222) || // ŠĐĆŽ & đšćž
      (event.keyCode === 186) || // Č & ć
      (event.keyCode === 32) // space
      ){
      this.state.searchText = this.state.searchText + event.key;
    }

    this.props.onSearchQueryChange(this.state.searchText);

    let options = []
    if (this.state.searchText !== "") {
      options = this.props.options;
    }

    this.setState({
      ...this.state,
      options: options,
    });

    if (this.currentHover) {
      //hover item which will be visible after filtering
      let item = this.currentHover;
      if (this.currentHover.classList.contains("empty")) {
        item = this.currentHover.nextElementSibling;
      } else {
        let index = parseInt(this.currentHover.getAttribute("data-index"));
        while (options.length <= index && item) {
          item = item.previousElementSibling;
          index--;
        }
      }
      item && this._hoverItem(item);
    }
  }

  _onInputKeyDown(event) {
    let item;
    switch (event.key) {
      case "Enter":
        if (this.currentHover) {
          this._selectOption(this.currentHover);
        }
        this.input.current.blur();
        event.preventDefault();
        return false;
      case "Tab":
        if (this.currentHover) {
          this._selectOption(this.currentHover);
        }
        break;
      case "Escape":
        this.input.current.blur();
        break;
      case "ArrowDown":
        if (this.currentHover && this.currentHover.nextElementSibling) {
          item = this.currentHover.nextElementSibling;
        } else {
          item = this.dropdown.current.firstElementChild;
        }
        this._makeOptionVisible(item, "DOWN");
        this._hoverItem(item);
        event.preventDefault();
        return false;
      case "ArrowUp":
        if (this.currentHover && this.currentHover.previousElementSibling) {
          item = this.currentHover.previousElementSibling;
        } else {
          item = this.dropdown.current.lastElementChild;
        }
        this._makeOptionVisible(item, "UP");
        this._hoverItem(item);
        event.preventDefault();
        return false;
    }
  }

  _onInputFocus(event) {
    const value = super.getValue();
    const option = this.state.options.find(option => option === value || this.getOptionValue(option) === value);
    if (option) {
      //hover selected item
      const optionValue = String(this.getOptionValue(option));
      for (let i = 0; i < this.dropdown.current.children.length; i++) {
        const item = this.dropdown.current.children[i];
        if (item.getAttribute("data-id") === optionValue) {
          this._hoverItem(item);
          break;
        }
      }
    } else if(this.dropdown.current.firstElementChild) {
      //hover first item
      this._hoverItem(this.dropdown.current.firstElementChild);
    }
    this.props.onFocus && event && this.props.onFocus(event);
  }

  _onInputBlur(event) {
    const value = event.currentTarget.value;
    const item = this.props.options.find(function (option) {
      return value === this.getOptionLabel(option);
    }.bind(this));
    if (!item) {
      this.setState({
        ...this.state,
        emptyOption: this.props.emptyOption,
        options: [...this.props.options],
        filter: this.props.emptyOption ? "" : this.state.lastValue
      })
    } else {
      //save selected item, to it is hovered when reopened
      for (let i = 0; i < this.dropdown.current.children.length; i++) {
        let option = this.dropdown.current.children[i];
        if (option.getAttribute("data-id") === this.getOptionValue(item)) {
          this.currentHover = option;
        }
      }
    }

    this.onBlur();
  }

  _onDropdownMouseMove(event) {
    if (event.target.tagName.toUpperCase() === "LI") {
      this._hoverItem(event.target);
    }
  }

  _onDropdownClick(event) {
    this._selectOption(event.target);
  }

  _hoverItem(item) {
    if (this.currentHover) {
      this.currentHover.classList.remove("hover");
    }
    this.currentHover = item;
    this.currentHover.classList.add("hover");
  }

  _selectOption(option) {
    const id = option.getAttribute("data-id");
    // const item = id ? this.props.options.find(option => id === String(this.getOptionValue(option))): null;
    let item = id ? this.props.options.find(function (option) {
      return id === String(this.getOptionValue(option));
    }.bind(this)) : null;

    if (!item){
      item = id ? this.state.multiselectItems.find(function (option) {
        return id === String(this.getOptionValue(option));
      }.bind(this)) : null;
    }

    this.setState({
      ...this.state,
      emptyOption: this.props.emptyOption,
      options: [...this.props.options],
      filter: this.getOptionLabel(item),
      lastValue: this.getOptionLabel(item),
    })
    if(typeof this.props.onChange !== "undefined") {
      this.props.onChange();
    }

    if(this.props.isMultiSelect) {
      const elementIndex = this.state.multiselectValues.indexOf(this.getOptionValue(item));
      if (elementIndex === -1) {
        this.state.multiselectValues.push(this.getOptionValue(item));
        this.state.multiselectCodes.push(this.getOptionCode(item));
      } else {
        this.state.multiselectValues.splice(elementIndex, 1);
        this.state.multiselectCodes.splice(elementIndex, 1);
      }


      this.state.options.map((option) => {
        if (this.state.multiselectCodes.includes(option.code)) {
          if (!this.state.multiselectItems.includes(option)) {
            this.state.multiselectItems.push(option);
          }
        } else {
          const index = this.state.multiselectItems.indexOf(option);
          if (index !== -1) {
            this.state.multiselectItems.splice(index, 1);
          }
        }
      });

      this.setState(prevState => {
        const uniqueItems = [];
        const seenCodes = new Set();

        for (const item of prevState.multiselectItems) {
          if (!seenCodes.has(item.code) && prevState.multiselectCodes.includes(item.code)) {
            uniqueItems.push(item);
            seenCodes.add(item.code);
          }
        }

        return { multiselectItems: uniqueItems };
      });
      this.onChange(this.state.multiselectValues);

      return;
    }
    this.onChange(this.getOptionValue(item));
  }

  _makeOptionVisible(option, direction) {
    const parent = option.parentElement;
    if (option.offsetTop < parent.scrollTop || //top visible
      option.offsetTop + option.clientHeight > parent.scrollTop + parent.clientHeight) { //bottom visible
      //not 100% visible
      if (direction === "UP") {
        parent.scrollTop = option.offsetTop;
      } else {
        parent.scrollTop = option.offsetTop + option.clientHeight - parent.clientHeight;
      }
    }
  }
}

Select.propTypes = {
  id: PropTypes.string,
  options: PropTypes.array.isRequired,
  optionsValue: PropTypes.array,
  optionsCode: PropTypes.string,
  optionsLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  optionsVisible: PropTypes.func,
  selectedItem: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  emptyOption: PropTypes.bool,
  emptyLabel: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  skipValidation: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  formField: PropTypes.object,
  isMultiSelect: PropTypes.bool,
  multiSelectValues: PropTypes.object,
  onSearchQueryChange: PropTypes.func,
};

export default Select
